import en from './en.json'
import it from './it.json'

export const adminsTranslations = {
	en,
	it
} as const
